import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from 'src/app/Chat.service';
import { HttpmethodsService } from 'src/app/demo/service/httpmethods.service';
import { BranchLoginMaster, BranchMaster } from '../modelClass';
import { branchMasterUrl, getAllWithStatus } from '../modelurl';

@Component({
  selector: 'app-selectbranchmaster',
  templateUrl: './selectbranchmaster.component.html',
  styleUrls: ['./selectbranchmaster.component.scss']
})
export class SelectbranchmasterComponent implements OnInit {

  branchloginMasterFrom: FormGroup;
  submitted: boolean = false;
  branchList:Array<BranchMaster>=[];
  branchId:any="";
  constructor(public formBuilder: FormBuilder, private spinner: NgxSpinnerService, private httpService: HttpmethodsService, private router: Router, private chatService: ChatService, private toastr: ToastrService) {
  }
  ngOnInit(): void {
    this.branchloginMasterFrom = this.formBuilder.group({
      branchId: new FormControl('', Validators.required)
    });
    this.getAllActiveBranch();
  }

  getAllActiveBranch() {
    this.spinner.show();
    this.httpService.getRequest(branchMasterUrl + getAllWithStatus + "/Active").subscribe((result: any) => {
      this.branchList = result;
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    })
  }

  submit()
  {
    this.submitted = true;
    if (this.branchloginMasterFrom.invalid) {
      return;
    }
    this.submitted = false;
    let branchObj = this.branchList.find(e=>e.branchId==this.branchId);
    localStorage.setItem('branchId', branchObj.branchId);
    localStorage.setItem('branchName', branchObj.branchName);
    this.router.navigateByUrl("dashboard/default");
  }
  get Validation() { return this.branchloginMasterFrom.controls };
}
